import { useEffect } from 'react';
import { useSelectedScope } from '@frontend/scope';
import { useNavigate, type AnyRoute } from '@frontend/weave-router';
import { resolveWorkspacePathDecision } from './decision-gate';

/**
 * Workspace Route Guard Hook
 *
 * Automatically redirects to /messages when in workspace mode and current route is blocked.
 * This prevents users from seeing the "No Access" page when switching to workspace mode
 * from routes that aren't allowed in workspace scope (e.g., home).
 *
 * Should be called once during app initialization.
 */
export const useWorkspaceRouteGuard = () => {
  const selectedScope = useSelectedScope();
  const navigate = useNavigate();

  useEffect(() => {
    // Only act when in workspace mode
    if (selectedScope?.scopeType !== 'workspace') {
      return;
    }

    const currentPath = window.location.pathname;
    const decision = resolveWorkspacePathDecision(selectedScope, currentPath);

    // If the current route is blocked in workspace mode, navigate to inbox
    if (decision.availability === 'blocked') {
      navigate({ to: '/messages/inbox' as AnyRoute });
    }
  }, [selectedScope, navigate]);
};
